import { render, staticRenderFns } from "./trainingComponent.vue?vue&type=template&id=a4a4c4a8"
import script from "./trainingComponent.vue?vue&type=script&lang=js"
export * from "./trainingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports